import { SurveyRow as ReactSurveyRow } from 'survey-react-ui';

import { SurveyRowElement } from '../SurveyRowElement/SurveyRowElement';

import css from './SurveyRow.module.scss';

export class SurveyRow extends ReactSurveyRow {
  protected renderElementContent(): JSX.Element {
    const elements = this.row.visibleElements.map((element, elementIndex) => {
      const index = elementIndex ? '-' + elementIndex : 0;
      const key = element.name + index;
      return (
        <SurveyRowElement
          element={element}
          index={elementIndex}
          row={this.row}
          survey={this.survey}
          creator={this.creator}
          css={this.css}
          key={key}
        ></SurveyRowElement>
      );
    });

    return <div className={css.root}>{elements}</div>;
  }
}
